<app-service-detail>
    <div class="service-preview {{isFullScreen ? 'full-screen' : ''}} container-fluid py-3">
        <div class="col-12">
            <div style="position: relative;">
                <div class="d-flex">
                    <a (click)="location.back()" class="btn btn-primary btn-rounded btn-md text-uppercase align-self-center exit-preview-mode ml-auto">
                        <span>{{ 'Exit preview mode' | translate }} <i class="far fa-times ml-3"></i></span>
                    </a>
                </div>
                <collapsible-pane title="{{ 'Service preview' | translate }}" (headerAction)="toggleFullScreenPreview()" [showHeaderBtn]="true" showHeaderBtnText="{{ 'Full screen mode' | translate }}">
                  <div class="w-100 preview-container">
                    <iframe *ngIf="previewUrl" #previewIframe
                            frameborder="0"
                            scrolling="no"
                            height="{{scrollHeight}}px"
                            width="100%"
                            [src]="previewUrl"></iframe>
                  </div>
                  <button class="preview-close btn btn-sm btn-dark" (click)="toggleFullScreenPreview()">{{ 'Close preview' | translate }}</button>
                </collapsible-pane>
            </div>
        </div>

        <div bsModal
             #childModal="bs-modal"
             class="modal"
             [config]="{backdrop: true, ignoreBackdropClick: true}"
             tabindex="-1"
             role="dialog"
             aria-labelledby="myLargeModalLabel"
             aria-hidden="true">
            <div class="rectangle modal-dialog"
                 [ngStyle]="style"
                 mwlResizable
                 [enableGhostResize]="true"
                 [resizeEdges]="{bottom: false, right: false, top: false, left: true}"
                 (resizeEnd)="onResizeEnd($event)">
                <div class="modal-content">
                    <div class="modal-header">
                        <button type="button"
                                class="close ml-3"
                                aria-label="Close"
                                (click)="closeModal($event);">
                          <span class="color-primary" aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <translations-edit *ngIf="action === 'translation_edit'"
                                       [previewTranslation]="previewTranslation"
                                       (modalClosedWithoutReloadEvent)="childModal.hide();"
                                       (modalClosedEvent)="closeModal($event)"></translations-edit>
                    <registration-edit *ngIf="action === 'edit' && serviceObject && serviceObject.type === 'registration'"
                                       [serviceId]="serviceId"
                                       [determinantMapById]="determinantMapById"
                                       [registration]="serviceObject.object"
                                       (modalClosedEvent)="closeModal($event)"></registration-edit>
                    <cost-edit *ngIf="action === 'edit' && serviceObject && serviceObject.type === 'cost'" (editCancel)="closeModal($event)"
                                [cost]="serviceObject.object.cost"
                                [determinantMapById]="determinantMapById"
                                [costView]="false"
                                [serviceId]="serviceId"
                                (formSubmit)="closeModal($event);"
                                class="row layer sub-layer px-3 pt-1">
                    </cost-edit>
                    <activity-condition-edit *ngIf="action === 'edit' && serviceObject && serviceObject.type === 'condition'"
                         [serviceId]="serviceId"
                         [registration]="registration"
                         [determinantMapById]="determinantMapById"
                         [activityCondition]="serviceObject.object"
                         class="row layer sub-layer px-3 pt-1">
                    </activity-condition-edit>
                </div>
            </div>
        </div>
    </div>
</app-service-detail>
